import React from 'react';

import Prism from 'prismjs';

import {copyToClipBoard} from '@edna/utils';

import {CopyIcon} from 'src/icons';

import * as S from './style';

export const JsonViewArea = React.memo<{data: TAnyObject; hasCopy?: boolean}>(({data, hasCopy}) => {
  React.useEffect(() => {
    Prism.highlightAll();
  }, [JSON.stringify(data)]);

  const handleCopy = React.useCallback(() => copyToClipBoard(JSON.stringify(data)), [data]);

  return (
    <S.Container>
      {hasCopy && (
        <S.FloatingButton size="S" square title="copy" onClick={handleCopy}>
          <CopyIcon />
        </S.FloatingButton>
      )}
      <S.Code>
        <pre>
          <code className="language-json">{JSON.stringify(data, null, 4)}</code>
        </pre>
      </S.Code>
    </S.Container>
  );
});

JsonViewArea.displayName = 'JsonViewArea';

export const PrettyJSON = React.memo<{json: TAnyObject}>(({json}) => {
  return <pre>{JSON.stringify(json, null, 4)}</pre>;
});

PrettyJSON.displayName = 'PrettyJSON';
